// @flow
import React from "react";
import type { FieldProps } from "redux-form";

import { Consumption, ConsumptionFF } from "Commons/Components";
import { isPresent } from "Commons/Utilities";
import type { CategoryT } from "../../../../../../Commons/Modules/category";

type ConsumptionFieldProps = {|
  showWarning: boolean,
  category: CategoryT,
  isCompany?: boolean,
  width?: number,
  primary?: boolean,
|} & FieldProps;

export const ConsumptionField = (props: ConsumptionFieldProps) => {
  const { showWarning, category, isCompany = false, width = 10 } = props;

  return (
    <Consumption
      className={showWarning && !isPresent(props.input.value) ? "warning" : ""}
      width={width}
      categoryType={category.categoryType}
      value={parseFloat(props.input.value)}
      inputName={props.input.name}
      onChange={({ value }) => props.input.onChange(value)}
      isCompany={isCompany}
    />
  );
};

export const ConsumptionFieldFF = (props: ConsumptionFieldProps) => {
  const { showWarning, category, isCompany = false, width = 10 } = props;

  return (
    <ConsumptionFF
      className={showWarning && !isPresent(props.input.value) ? "warning" : ""}
      width={width}
      categoryType={category.categoryType}
      value={parseFloat(props.input.value)}
      inputName={props.input.name}
      onChange={({ value }) => props.input.onChange(value)}
      isCompany={isCompany}
    />
  );
};
